import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderColor: (p) => p.palette.grey[300],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: (p) => p.spacing(1),
  pb: 1.5,
  pl: 1.5,
  maxWidth: (p) => p.spacing(42.5),
};

export const description: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  color: (p) => p.palette.grey[500],
  pr: 1.5,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
};
